var map = {
	"./de/animals.json": [
		467,
		467
	],
	"./de/cars.json": [
		2053,
		53
	],
	"./de/city-country.json": [
		7474,
		474
	],
	"./de/food.json": [
		1954,
		954
	],
	"./de/literature.json": [
		9181,
		181
	],
	"./de/people.json": [
		3073,
		73
	],
	"./de/sports.json": [
		6085,
		85
	],
	"./de/things.json": [
		4847,
		847
	],
	"./de/tv.json": [
		1216,
		216
	],
	"./de/web.json": [
		7832,
		832
	],
	"./en/animals.json": [
		4759,
		759
	],
	"./en/cars.json": [
		4425,
		425
	],
	"./en/city-country.json": [
		7446,
		446
	],
	"./en/food.json": [
		7014,
		14
	],
	"./en/literature.json": [
		5313,
		313
	],
	"./en/people.json": [
		2069,
		69
	],
	"./en/sports.json": [
		5897,
		897
	],
	"./en/things.json": [
		7947,
		947
	],
	"./en/tv.json": [
		580,
		580
	],
	"./en/web.json": [
		3172,
		172
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 89;
module.exports = webpackAsyncContext;